import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { estadosEvento, hotelesOpciones, tiposDeeventosSelect } from "../../../hook/Arreglos";
import { obtenerListaSalones } from "../../../store/Calendario/thunkCalendario";
import { obtenerListaEmpresas } from "../../../store/Empresa/thunkEmpresa";
import { setLimpiarTemporales } from "../../../store/Eventos/eventoSlice";
import { cancelarEventosReasignacion, DatosEventos, editarEvento, eliminarEventosReasignacion } from "../../../store/Eventos/thunkEventos";
import { obtenerAdministradores } from "../../../store/admin/thunkAdmins";
import { traerTodoslosClientesSegunlaempresa } from "../../../store/clientes/thunkClientes";
import { ListaEventoTemporal } from "../Calendario/ListaEventoTemporal";
import { UnificarModales } from "../Modales/UnificarModales";
import { ListaEventoAsignados } from "./ListaEventoAsignados";
import { ModalMostrarCalendario } from "./ModalMostrarCalendario";

export const EditarEvento = () => {
    const navigate = useNavigate();
    // Redux hooks para manejar el estado global y despachar acciones.
    // `useSelector` se utiliza para seleccionar datos específicos del estado global.
    // `useDispatch` se utiliza para despachar acciones de Redux.
    const { eventosSeleccionados } = useSelector((state) => state.evento); // Eventos seleccionados del estado global.
    const { id_admin, name_admin } = useSelector((state) => state.auth);
    const dispatch = useDispatch(); // Hook para despachar acciones a Redux.

    // Estado local para manejar la apertura y cierre del modal.
    const [openModal, setOpenModal] = useState(false); // Controla si el modal está abierto o cerrado.

    // Estado local para almacenar los datos del formulario.
    // Inicializamos con valores predeterminados.
    const [forms, setForms] = useState({
        selectedHotels: [], // Lista de hoteles seleccionados (id y nombre).
        selectedExecutives: [], // Lista de ejecutivos seleccionados (nombres e ids).
        tipodeeventos: "", // Tipo de evento seleccionado.
        selectedSalones: [], // Lista de salones seleccionados (id y nombre).
        estadoEvento: "", // Estado del evento actual.
        nombreEvento: "", // Nombre del evento.
        ingresoMonto: "", // Monto de ingreso asociado al evento.
        montajeEvento: "", // Detalles del montaje del evento.
        cantidadPersonas: 0, // Cantidad de personas esperadas (por defecto "--").
        notasEvento: "--", // Notas adicionales del evento (por defecto "--").
        empresaSeleccionada: "", // Empresa seleccionada en el formulario.
        clienteSeleccionado: "", // Cliente seleccionado en el formulario.
        datosCliente: [], // Detalles del cliente seleccionado.
        errors: {}, // Inicializar para manejar los errores
        listaEventosAsignados: [], // Lista de eventos asignados al evento principal.
        token: "", // Token único del evento.
        usuariosPersmisos: false, // Usuarios con permisos
    });

    // Estado local para manejar el color asociado al estado del evento.
    const [colorEstado, setColorEstado] = useState(""); // Se actualiza en función del estado del evento seleccionado.

    // Estado local para almacenar las opciones disponibles de administradores.
    const [administradoresOptions, setAdministradoresOptions] = useState([]); // Lista de opciones de administradores.

    // Estado local para almacenar las opciones disponibles de empresas.
    const [empresasOptions, setEmpresasOptions] = useState([]); // Lista de opciones de empresas.

    // Estado local para manejar las opciones y datos de los clientes.
    const [clienteOptions, setClienteOptions] = useState([]); // Opciones del cliente para el selector.
    const [todosLosclientes, setTodosLosclientes] = useState([]); // Lista completa de clientes disponibles.

    // Función para abrir el modal.
    // Se utiliza para activar el estado `openModal`.
    const handleOpen = () => setOpenModal(true);

    // Función para cerrar el modal.
    // Cambia el estado `openModal` a falso.
    const handleClose = () => setOpenModal(false);

    /**
     * Obtiene el nombre del hotel dado su ID.
     * @param {string|number} idHotel - ID del hotel.
     * @returns {string} Nombre del hotel o "No encontrado" si no se encuentra.
     */
    const obtenerNombreHotel = (idHotel) => hotelesOpciones.find((opcion) => opcion.value === idHotel?.toString())?.label || "No encontrado";
    /**
     * Actualiza la lista de hoteles seleccionados en el estado del formulario
     * a partir de los eventos seleccionados.
     * @param {Array} eventos - Lista de eventos seleccionados.
     */
    const updateSelectedHotels = (eventos, listaLocal) => {
        setForms((prevForms) => {
            // Crear un conjunto con los IDs de hoteles asociados a los eventos seleccionados.
            const selectedEventHotelIds = new Set(eventos.map((evento) => evento.hotelid));

            // Crear un conjunto con los IDs de hoteles asociados a la lista local.
            const selectedLocalHotelIds = new Set(listaLocal.map((item) => item.hotelid));

            // Combinar ambos conjuntos para obtener un conjunto único de IDs de hoteles.
            const combinedHotelIds = new Set([...selectedEventHotelIds, ...selectedLocalHotelIds]);

            // Filtrar los hoteles actualmente seleccionados que todavía están en los eventos o lista local seleccionados.
            const filteredHotels = prevForms.selectedHotels.filter((hotel) => combinedHotelIds.has(hotel.idHotel));

            // Mapear los IDs combinados para obtener nuevos hoteles, asegurándose de evitar duplicados.
            const newHotels = Array.from(combinedHotelIds).map((idHotel) => ({
                idHotel, // ID único del hotel.
                nombreHotel: obtenerNombreHotel(idHotel), // Función para obtener el nombre del hotel.
            }));

            // Combinar los hoteles filtrados y los nuevos, eliminando duplicados.
            const updatedHotels = [...filteredHotels, ...newHotels.filter((newHotel) => !filteredHotels.some((filteredHotel) => filteredHotel.idHotel === newHotel.idHotel))];

            // Actualizar el estado con la lista de hoteles únicos.
            return {
                ...prevForms, // Mantener otros valores actuales del formulario.
                selectedHotels: updatedHotels, // Nueva lista de hoteles únicos seleccionados.
            };
        });
    };

    /**
     * Actualiza la lista de salones seleccionados en el estado del formulario
     * a partir de los eventos seleccionados.
     * @param {Array} eventos - Lista de eventos seleccionados.
     */
    const updateSelectedSalones = (eventos, listaLocal) => {
        setForms((prevForms) => {
            // Crear conjuntos con los IDs de salones asociados a los eventos y listaLocal seleccionados.
            const selectedSalonIdsFromEventos = new Set(eventos.map((evento) => evento.salonid));
            const selectedSalonIdsFromListaLocal = new Set(listaLocal.map((local) => local.salonid));

            // Filtrar los salones actualmente seleccionados que todavía están en los eventos o listaLocal seleccionados.
            const filteredSalones = prevForms.selectedSalones.filter((salon) => selectedSalonIdsFromEventos.has(salon.idSalones) || selectedSalonIdsFromListaLocal.has(salon.idSalones));

            // Mapear los eventos para obtener nuevos salones y eliminar duplicados existentes.
            const newSalonesFromEventos = eventos
                .map(({ salonid, nombreSalon }) => ({
                    idSalones: salonid, // ID único del salón.
                    nombreSalon, // Nombre del salón directamente del evento.
                }))
                .filter((salon) => !filteredSalones.some((s) => s.idSalones === salon.idSalones)); // Evitar duplicados.

            // Mapear listaLocal para obtener nuevos salones y eliminar duplicados existentes.
            const newSalonesFromListaLocal = listaLocal
                .map(({ salonid, nombreSalon }) => ({
                    idSalones: salonid, // ID único del salón.
                    nombreSalon, // Nombre del salón directamente del local.
                }))
                .filter((salon) => !filteredSalones.some((s) => s.idSalones === salon.idSalones)); // Evitar duplicados.

            // Combinar los salones filtrados y los nuevos, y actualizar el estado.
            return {
                ...prevForms, // Mantener otros valores actuales del formulario.
                selectedSalones: [...filteredSalones, ...newSalonesFromEventos, ...newSalonesFromListaLocal], // Nueva lista de salones seleccionados.
            };
        });
    };

    /**
     * Configura las opciones de administradores y selecciona un administrador predeterminado si está disponible.
     */
    const configurarAdministradores = useCallback(
        async (idUsers) => {
            /**
             * Convierte una lista de objetos en opciones para un selector.
             * @param {Array} data - Datos originales provenientes de la API.
             * @param {string} valueKey - Clave que representa el valor único en las opciones.
             * @param {string} labelKey - Clave que representa la etiqueta mostrada en las opciones.
             * @returns {Array} Opciones formateadas para un selector.
             */
            const mapToOptions = (data, valueKey, labelKey) =>
                data.map((item) => ({
                    value: item[valueKey],
                    label: item[labelKey],
                }));

            try {
                // Llama a la acción Redux para obtener los datos de administradores desde la API.
                const response = await dispatch(obtenerAdministradores());
                if (response && Array.isArray(response)) {
                    // Mapea los datos recibidos de la API a un formato de opciones para un selector.
                    const adminOptions = mapToOptions(response, "id_admin", "name_admin");

                    // Actualiza el estado con las opciones de administradores.
                    setAdministradoresOptions(adminOptions);

                    /**
                     * Limpia una cadena eliminando las comillas simples y dobles.
                     * @param {string} idUsers - Cadena original con IDs.
                     * @returns {string} Cadena limpia sin comillas.
                     */
                    const limpiarCampos = (idUsers) => {
                        return idUsers.replace(/["']/g, ""); // Reemplaza todas las comillas dobles y simples.
                    };

                    // Limpia los IDs de usuarios proporcionados.
                    const resultado = limpiarCampos(idUsers);

                    // Divide la cadena de IDs en un array y los convierte en números.
                    const userIds = resultado.split(",").map((id) => parseInt(id.trim(), 10));

                    // Filtra las opciones que coincidan con los IDs proporcionados.
                    const selectedAdmins = adminOptions.filter((option) => userIds.includes(option.value));

                    // Si se encuentran opciones coincidentes, actualiza el estado del formulario.
                    if (selectedAdmins.length > 0) {
                        setForms((prevForms) => ({
                            ...prevForms, // Mantén los valores actuales del formulario.
                            selectedExecutives: selectedAdmins, // Configura los administradores seleccionados.
                        }));
                    }
                }
            } catch (error) {
                // Manejo de errores: Loguea cualquier problema que ocurra durante la obtención de administradores.
                console.error(`Error al obtener administradores: ${error.message}`);
            }
        },
        [dispatch],
    );

    /**
     * Configura las opciones de empresas.
     */
    const configurarEmpresas = useCallback(
        async (idEmpresa) => {
            /**
             * Convierte una lista de objetos en opciones para un selector.
             * @param {Array} data - Datos originales provenientes de la API.
             * @param {string} valueKey - Clave que representa el valor único en las opciones.
             * @param {string} labelKey - Clave que representa la etiqueta mostrada en las opciones.
             * @returns {Array} Opciones formateadas para un selector.
             */
            const mapToOptions = (data, valueKey, labelKey) =>
                data.map((item) => ({
                    value: item[valueKey],
                    label: item[labelKey],
                }));

            try {
                // Llama a la acción Redux para obtener los datos de empresas desde la API.
                const response = await dispatch(obtenerListaEmpresas());
                if (response && Array.isArray(response)) {
                    // Mapea los datos recibidos de la API a un formato de opciones para un selector.
                    const empresaOptions = mapToOptions(response, "id_empresa", "nombre_empresa");

                    // Actualiza el estado con las opciones de empresas disponibles.
                    setEmpresasOptions(empresaOptions);

                    // Busca la empresa que coincide con el ID proporcionado.
                    const preselectedEmpresa = empresaOptions.find((option) => option.value === idEmpresa);

                    // Si encuentra una empresa preseleccionada, actualiza el estado del formulario.
                    if (preselectedEmpresa) {
                        setForms((prevForms) => ({
                            ...prevForms, // Mantén los valores actuales del formulario.
                            empresaSeleccionada: preselectedEmpresa, // Configura la empresa seleccionada.
                        }));
                    }
                }
            } catch (error) {
                // Manejo de errores: Loguea cualquier problema que ocurra durante la obtención de empresas.
                console.error(`Error al obtener empresas: ${error.message}`);
            }
        },
        [dispatch],
    );

    // Función para obtener el valor de un parámetro específico de la URL.
    const getQueryParam = (param) => {
        // Crea una instancia de 'URLSearchParams' con los parámetros de la URL.
        const params = new URLSearchParams(window.location.search);
        const value = params.get(param);

        // Retorna el valor como número si es numérico, o como cadena si no lo es.
        if (value !== null && !isNaN(value) && !isNaN(parseFloat(value))) {
            return Number(value);
        }
        return value; // Retorna null o el valor original como cadena.
    };

    // Función para extraer datos del evento desde la API.
    const extraerDatosEventoApi = useCallback(
        async (eventoId) => {
            // Validación inicial: Verifica si el ID del evento es válido.
            if (!eventoId) {
                console.warn("El ID del evento es inválido o no está definido.");
                return; // Termina la ejecución si el eventoId no es válido.
            }

            try {
                Swal.fire({
                    title: "Cargando datos",
                    text: "Favor esperar hasta que el proceso termine",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading(); // Muestra un indicador de carga
                    },
                });
                // Llama a la acción Redux para obtener los datos principales del evento desde la API.
                const datos = await dispatch(DatosEventos(eventoId));

                // Obtiene la lista de salones para el hotel relacionado con el evento principal.
                const nombreSalon = await dispatch(obtenerListaSalones(datos.eventoPrincipal.id_hotel));
                const salonEncontrado = nombreSalon.find((salon) => salon.id_salon === datos.eventoPrincipal.id_salon);

                // Inicializa el array para almacenar los eventos mapeados.
                const eventos = [];

                // Mapea el evento principal con los datos necesarios.
                const mappedEventoPrincipal = {
                    idTemporal: datos.eventoPrincipal.id_evento,
                    _id: datos.eventoPrincipal.id_evento, // ID único del evento.
                    resourceId: datos.eventoPrincipal.id_salon, // ID del salón asociado.
                    title: datos.eventoPrincipal.nombre_evento, // Nombre del evento.
                    start: datos.eventoPrincipal.fech_Inicio_evento, // Fecha de inicio.
                    end: datos.eventoPrincipal.fech_final_evento, // Fecha de finalización.
                    color: datos.eventoPrincipal.color_evento, // Color asignado.
                    user: datos.eventoPrincipal.id_usuarios, // ID del usuario relacionado.
                    estadoid: datos.eventoPrincipal.estado_evento, // Estado del evento.
                    salonid: datos.eventoPrincipal.id_salon, // ID del salón.
                    hotelid: datos.eventoPrincipal.id_hotel, // ID del hotel.
                    ids: datos.eventoPrincipal.id_evento, // Alias del identificador del evento.
                    token: datos.eventoPrincipal.id_referencia, // Token o referencia única.
                    selectOverlap: true, // Permite selección de eventos superpuestos.
                    temporal: false, // No es un evento temporal.
                    nombreSalon: salonEncontrado?.nombre_salon || "Salón desconocido", // Nombre del salón.
                    temporalEditar: false, // Marca de edición para eventos no temporales.
                };

                // Agrega el evento principal al array de eventos.
                eventos.push(mappedEventoPrincipal);

                // Procesa los eventos relacionados.
                for (const evento of datos.eventosRelacionados) {
                    const salonesRelacionados = await dispatch(obtenerListaSalones(evento.id_hotel));
                    const salonRelacionado = salonesRelacionados.find((salon) => salon.id_salon === evento.id_salon);

                    // Mapea cada evento relacionado.
                    const mappedEventoRelacionado = {
                        idTemporal: evento.id_evento,
                        _id: evento.id_evento, // ID único del evento.
                        resourceId: evento.id_salon, // ID del salón asociado.
                        title: evento.nombre_evento, // Nombre del evento.
                        start: evento.fech_Inicio_evento, // Fecha de inicio.
                        end: evento.fech_final_evento, // Fecha de finalización.
                        color: evento.color_evento, // Color asignado.
                        user: evento.id_usuarios, // ID del usuario relacionado.
                        estadoid: evento.estado_evento, // Estado del evento.
                        salonid: evento.id_salon, // ID del salón.
                        hotelid: evento.id_hotel, // ID del hotel.
                        ids: evento.id_evento, // Alias del identificador del evento.
                        token: evento.id_referencia, // Token o referencia única.
                        selectOverlap: true, // Permite selección de eventos superpuestos.
                        temporal: false, // No es un evento temporal.
                        nombreSalon: salonRelacionado?.nombre_salon || "Salón desconocido", // Nombre del salón.
                        temporalEditar: false, // Marca de edición para eventos no temporales.
                    };

                    // Agrega el evento relacionado al array de eventos.
                    eventos.push(mappedEventoRelacionado);
                }

                const user = datos.eventoPrincipal.id_usuarios;
                // Extraer solo los números de la cadena
                const cleanedNumbers = user.match(/\d+/g).join(","); // Ejemplo: "90,91"

                // Convertir cleanedNumbers en un array para buscar dentro
                const permisos = [...new Set([...cleanedNumbers.split(",").map(Number), 61, 56,108])]; // Agregamos permisos 61 y 56 siempre



                let permiso = false;

                // Validar si el id del admin está en los permisos
                if (permisos.includes(id_admin)) {
                    permiso = true;
                }

                // Actualiza el estado del formulario con los datos principales del evento.
                setForms((prevForms) => ({
                    ...prevForms,
                    nombreEvento: datos.eventoPrincipal.nombre_evento,
                    ingresoMonto: datos.eventoPrincipal.ingresos_evento,
                    montajeEvento: datos.eventoPrincipal.montaje,
                    cantidadPersonas: datos.eventoPrincipal.cantidad_evento,
                    notasEvento: datos.eventoPrincipal.notas_evento,
                    tipodeeventos: datos.eventoPrincipal.tipo_evento,
                    estadoEvento: datos.eventoPrincipal.estado_evento,
                    listaEventosAsignados: eventos,
                    token: datos.eventoPrincipal.id_referencia,
                    usuariosPersmisos: permiso,
                }));

                // Configura los administradores relacionados con el evento.
                configurarAdministradores(datos.eventoPrincipal.id_usuarios);

                // Configura la empresa asociada al evento.
                configurarEmpresas(datos.eventoPrincipal.idEmpresaEvento);
                await ejecutarFuncionAdicional(datos.eventoPrincipal.idEmpresaEvento, 0, datos.eventoPrincipal.id_cleinteev);
                if (datos.eventoPrincipal.id_cleinteev > 0) {
                    seleccionarClienteDefecto(datos.eventoPrincipal.id_cleinteev);
                }

                // Busca y actualiza el color del estado del evento si está disponible.
                const estadoSeleccionado = estadosEvento.find((estado) => estado.id_estado === Number(datos.eventoPrincipal.estado_evento));

                if (estadoSeleccionado) {
                    setColorEstado(estadoSeleccionado.color_estado);
                } else {
                    console.warn("Estado no encontrado. Se limpiará el color asociado.");
                    setColorEstado(""); // Limpia el color del estado para evitar inconsistencias.
                }
                Swal.close();
            } catch (error) {
                Swal.close();
                // Manejo de errores: Loguea cualquier problema ocurrido durante el proceso.
                console.error(`Error al obtener los datos del evento: ${error.message}`);
            }
        },
        [dispatch, configurarAdministradores, configurarEmpresas, estadosEvento], // Dependencias necesarias para garantizar consistencia.
    );

    // Ejecuta `useEffect` al montar el componente.
    useEffect(() => {
        // Limpia los eventos temporales al montar el componente.
        dispatch(setLimpiarTemporales());

        // Extrae el ID del evento desde la URL.
        const eventoId = getQueryParam("data");

        // Verifica si el ID del evento es válido antes de intentar extraer datos.
        extraerDatosEventoApi(eventoId);

        // Ejecuta configuraciones adicionales.
    }, [dispatch, extraerDatosEventoApi]);

    useEffect(() => {
        updateSelectedHotels(eventosSeleccionados, forms.listaEventosAsignados); // Actualiza los hoteles basados en los eventos seleccionados.
        updateSelectedSalones(eventosSeleccionados, forms.listaEventosAsignados); // Actualiza los salones basados en los eventos seleccionados.
    }, [forms.listaEventosAsignados, eventosSeleccionados]);

    /**
     * Maneja los cambios en la selección de un campo del formulario.
     * @param {any} value - Valor ingresado o seleccionado en el campo.
     * @param {string} field - Nombre del campo en el formulario que se está actualizando.
     */
    const handleChange = (value, field) => {
        // Actualiza dinámicamente el estado del formulario con el valor proporcionado.
        setForms((prevForms) => {
            const isError = value === "" || (Array.isArray(value) && value.length === 0); // Verifica si el campo está vacío

            return {
                ...prevForms,
                [field]: value, // Actualiza el valor del campo
                errors: {
                    ...prevForms.errors,
                    [field]: isError, // Marca error si está vacío
                },
            };
        });

        // Validación específica para el campo "estadoEvento".
        if (field === "estadoEvento") {
            // Busca en la lista de estados el estado seleccionado basado en su ID.
            const estadoSeleccionado = estadosEvento.find(
                (estado) => estado.id_estado === Number(value), // Conversión explícita a número para evitar errores de tipo.
            );

            if (estadoSeleccionado) {
                // Si se encuentra el estado, actualiza el color asociado al estado seleccionado.
                setColorEstado(estadoSeleccionado.color_estado);
            } else {
                // Si no se encuentra el estado, muestra un mensaje en la consola y limpia el color.
                console.log("Estado no encontrado.");
                setColorEstado(""); // Limpia el color del estado en caso de error o selección inválida.
            }
        }
    };

    // Función para borrar los datos del formulario relacionados con la empresa y el cliente.
    const borrarDatos = () => {
        // Actualizamos el estado del formulario para reiniciar los campos específicos.
        setForms((prevForms) => ({
            ...prevForms, // Mantenemos los valores actuales del formulario.
            empresaSeleccionada: "", // Reiniciamos el campo de empresa seleccionada.
            clienteSeleccionado: "", // Reiniciamos el cliente seleccionado.
            datosCliente: "", // Borramos los datos del cliente.
        }));

        // Limpiamos las opciones disponibles de clientes en el selector.
        setClienteOptions([]);
        // Limpiamos la lista de todos los clientes.
        setTodosLosclientes([]);

        configurarEmpresas(); // Volvemos a cargar las opciones de empresas.
    };

    // Función para ejecutar una lógica adicional cuando se selecciona una empresa.
    const ejecutarFuncionAdicional = async (selected, vst, idCliente = 0) => {
        try {
            // Reiniciamos los campos del cliente en el formulario.
            setForms((prevForms) => ({
                ...prevForms, // Mantenemos los valores actuales del formulario.
                clienteSeleccionado: "", // Reiniciamos el cliente seleccionado.
                datosCliente: "", // Borramos los datos del cliente.
            }));

            // Limpiamos las opciones del cliente y la lista general antes de cargar los nuevos datos.
            setClienteOptions([]);
            setTodosLosclientes([]);

            // Despachamos una acción para obtener los clientes de la empresa seleccionada.
            const leadData = await dispatch(
                traerTodoslosClientesSegunlaempresa(vst === 1 ? selected?.value : selected), // Pasamos el valor de la empresa seleccionada.
            );



            // Mapeamos los datos obtenidos para formar las opciones del selector.
            const options = leadData.map((cliente) => ({
                value: cliente.id_cliente, // ID del cliente como valor.
                label: cliente.nombre_cliente, // Nombre del cliente como etiqueta.
            }));

            if (vst === 0) {
                const defaultClient = options.find((option) => option.value === idCliente);

                if (defaultClient) {
                    setForms((prevForms) => ({
                        ...prevForms,
                        clienteSeleccionado: defaultClient, // Establecemos el cliente seleccionado.
                    }));
                }
            }

            // Actualizamos las opciones disponibles en el selector de clientes.
            setClienteOptions(options);
            // Almacenamos todos los datos de los clientes obtenidos.
            setTodosLosclientes(leadData);
        } catch (error) {
            // En caso de error, mostramos un mensaje en la consola.
            console.error("Error al cargar los clientes:", error);

            // Limpiamos las opciones y la lista de clientes para garantizar un estado consistente.
            setClienteOptions([]);
            setTodosLosclientes([]);
        }
    };

    const seleccionarClienteDefecto = async (todosLosclientes, selectedId) => {
        if (selectedId) {
            if (!todosLosclientes || todosLosclientes.length === 0) {
                // console.error("La lista de clientes no está inicializada o está vacía.");
                return;
            }

            // Filtramos la lista de todos los clientes para encontrar el cliente seleccionado.
            const clientesFiltrados = todosLosclientes.filter(
                (cliente) => cliente.id_cliente === selectedId.clienteSeleccionado.value, // Comparamos con el ID seleccionado.
            );
            // Actualizamos el formulario con los datos del cliente seleccionado.
            setForms((prevForms) => ({
                ...prevForms, // Mantenemos los valores actuales del formulario.
                datosCliente: clientesFiltrados[0], // Asignamos los datos del cliente encontrado.
            }));
        } else {
            // Si no se seleccionó ningún cliente, mostramos un mensaje en la consola.
            // console.log("No se seleccionó ningún cliente.");
        }
    };

    useEffect(() => {
        seleccionarClienteDefecto(todosLosclientes, forms); // Actualiza los hoteles basados en los eventos seleccionados.
    }, [todosLosclientes]);

    // Función para manejar la selección de un cliente en el selector.
    const seleccionarCliente = async (selected) => {
        if (selected) {
            // Logueamos el cliente seleccionado en la consola.

            // Filtramos la lista de todos los clientes para encontrar el cliente seleccionado.
            const clientesFiltrados = todosLosclientes.filter(
                (cliente) => cliente.id_cliente === selected?.value, // Comparamos con el ID seleccionado.
            );

            // Actualizamos el formulario con los datos del cliente seleccionado.
            setForms((prevForms) => ({
                ...prevForms, // Mantenemos los valores actuales del formulario.
                datosCliente: clientesFiltrados[0], // Asignamos los datos del cliente encontrado.
            }));
        } else {
            // Si no se seleccionó ningún cliente, mostramos un mensaje en la consola.
            // console.log("No se seleccionó ningún cliente.");
        }
    };



    /**
     * Maneja el evento de envío del formulario.
     * @param {Event} e - Evento del formulario.
     */
    const validateForm = () => {
        const newErrors = {
            tipodeeventos: !forms.tipodeeventos,
            selectedExecutives: !forms.selectedExecutives || forms.selectedExecutives.length === 0,
            estadoEvento: !forms.estadoEvento,
            nombreEvento: !forms.nombreEvento,
            ingresoMonto: !forms.ingresoMonto,
            montajeEvento: !forms.montajeEvento,
            cantidadPersonas: !forms.cantidadPersonas,
        };

        setForms((prevForms) => ({
            ...prevForms,
            errors: newErrors,
        }));

        return !Object.values(newErrors).some((error) => error); // Retorna true si no hay errores
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!validateForm()) {
            // Mostrar alerta si los campos están vacíos
            await Swal.fire({
                icon: "error",
                title: "Campos incompletos",
                text: "Por favor, llena todos los campos para continuar.",
            });
            return;
        }

        if (forms.empresaSeleccionada.length === 0 || forms.clienteSeleccionado.length === 0) {
            // Mostrar alerta con confirmación si no se selecciona una empresa o cliente
            const result = await Swal.fire({
                icon: "warning",
                title: "Empresa o cliente no seleccionados",
                text: "Estás editando un evento sin empresa ni cliente. Si deseas continuar, haz clic en Aceptar. Si no, cancela esta operación y selecciona una empresa y cliente para continuar.",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "cancelar accion",
            });

            if (!result.isConfirmed) {
                // Si el usuario cancela, no se continúa
                return;
            }
        }

        if ((!forms.listaEventosAsignados || forms.listaEventosAsignados.length === 0) && (!eventosSeleccionados || eventosSeleccionados.length === 0)) {
            // Mostrar alerta con confirmación si no se selecciona una fecha
            await Swal.fire({
                icon: "warning",
                title: "Lo sentimos",
                text: "No existe una fecha seleccionada. Por favor, verifica que al menos tengas una fecha asignada para poder continuar.",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "cancelar accion",
            });
            return;
        }

        // Mostrar confirmación final antes de proceder
        const finalResult = await Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Deseas editar el evento?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, editar",
            cancelButtonText: "cancelar accion",
        });

        if (finalResult.isConfirmed) {
            const result = await dispatch(editarEvento(forms, eventosSeleccionados)); // Despachar acción para editar el evento

            if (result === "ok") {
                // Mostrar alerta de éxito y redirigir
                Swal.fire({
                    title: "¡Éxito!",
                    text: "El evento se editó correctamente.",
                    icon: "success",
                    showConfirmButton: true,
                }).then(() => {
                    dispatch(setLimpiarTemporales());
                    navigate("/calendario/ver");
                });
            } else {
                // // Mostrar alerta si hay un error al editar el evento
                // await Swal.fire({
                //     icon: "error",
                //     title: "Error al editar el evento",
                //     text: "Ocurrió un error al intentar editar el evento. Por favor, intenta de nuevo.",
                // });
            }
        }
    };

    // Función para eliminar eventos específicos de la lista
    const eliminarEventos = (id) => {
        if (!forms.usuariosPersmisos) {
            Swal.fire({
                icon: "error",
                title: `Lo sentimos ${name_admin}`,
                html: `
                                    No puedes eliminar el evento seleccionado sin los permisos adecuados. 
                                    Por favor, contacta a los ejecutivos asignados para obtener la autorización necesaria.
                                    <br/><br/>
                                `,
                confirmButtonText: "Entendido",
            });
            return;
        }
        Swal.fire({
            title: "¿Está seguro de eliminar el evento?",
            text: "Se eliminará temporalmente el evento seleccionado. Hasta que se dé clic en el botón editar, ya no se podrá revertir la acción.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí eliminar",
            cancelButtonText: "cancelar accion",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                // Verifica si el usuario confirmó la acción
                // Actualizar el estado de los formularios utilizando setForms
                setForms((prevForms) => {
                    // Filtrar los eventos de la lista actual, eliminando aquellos que cumplan con las siguientes condiciones:
                    // 1. `temporal` es `false`: El evento no es temporal.
                    // 2. `temporalEditar` es `false`: El evento no está siendo editado como temporal.
                    // 3. `idTemporal` coincide con el ID proporcionado como argumento.
                    const eventosFiltrados = prevForms.listaEventosAsignados.filter((evento) => !(evento.temporal === false && evento.temporalEditar === false && evento.idTemporal === id));

                    // Retornar el nuevo estado actualizado con la lista de eventos filtrados.
                    return {
                        ...prevForms, // Mantener el resto de las propiedades del estado actual.
                        listaEventosAsignados: eventosFiltrados, // Actualizar solo la lista de eventos asignados.
                    };
                });
            }
        });
    };

    const EliminarEventoBasedeDatos = (id) => {
        Swal.fire({
            title: `¿Está seguro de eliminar el evento ?`,
            text: "Esta acción no se puede revertir. Se eliminará completamente.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí eliminar",
            cancelButtonText: "cancelar accion",
            reverseButtons: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                await dispatch(eliminarEventosReasignacion(id)); // Llama a la acción para eliminar
                Swal.fire({
                    title: "Eliminado",
                    text: "El evento se ha eliminado con éxito.",
                    icon: "success",
                }).then(() => {
                    navigate("/calendario/ver"); // Redirige tras confirmar
                });
            }
        });
    };

    const cancelarEvento = (id) => {
        Swal.fire({
            title: `¿Está seguro de cancelar el evento?`,
            text: "Esta acción no se puede revertir. El evento se cancelará completamente.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí cancelar",
            cancelButtonText: "cancelar accion",
            reverseButtons: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                await dispatch(cancelarEventosReasignacion(id)); // Llama a la acción para cancelar
                Swal.fire({
                    title: "Cancelado",
                    text: "El evento se ha cancelado con éxito.",
                    icon: "success",
                }).then(() => {
                    navigate("/calendario/ver"); // Redirige tras confirmar
                });
            }
        });
    };

    const generarCopia = () => {
        const eventoId = getQueryParam("data");
        navigate(`/evento/copia?data=${eventoId}`);
    };

    const generarCotizacion = () => {
        navigate(`/cotizaciones/crear?data=${forms.token}`);
    };

    return (
        <div>
            <h4>Formulario de editar Editar evento</h4>
            {!forms.usuariosPersmisos && (
                <div role="alert" className="alert alert-danger fade show">
                    No tienes permiso para hacer acciones sobre este evento
                </div>
            )}
            {/* Botón para abrir el modal */}

            <div className="d-flex justify-content-between align-items-center mb-3">
                <button onClick={handleOpen} className="btn btn-dark">
                    Desplegar Calendario dinamico
                </button>
                <UnificarModales />
            </div>
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        <h5>Acciones de evento</h5>
                    </div>
                    <div className="card-body">
                        {forms.usuariosPersmisos && (
                            <>
                                <p>Acciones de eliminar y cancelar </p>
                                <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
                                    <button type="button" className="btn-shadow btn btn-danger" onClick={() => cancelarEvento(forms.token)}>
                                        Cancelar evento
                                    </button>
                                    <button type="button" className="btn-shadow btn btn-danger" onClick={() => EliminarEventoBasedeDatos(forms.token)}>
                                        Eliminar evento
                                    </button>
                                </div>
                                <hr />
                            </>
                        )}

                        <p>Acciones de Generar copia o Generar Cotización</p>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <button type="button" className="btn-shadow btn btn-success" onClick={() => generarCopia()}>
                                Generar Copia
                            </button>
                            <button type="button" className="btn-shadow btn btn-warning" onClick={() => generarCotizacion()}>
                                Generar Cotización
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Formulario para crear evento */}
            <form onSubmit={handleSubmit} autoComplete="off">
                <fieldset disabled={!forms.usuariosPersmisos}>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Informacion de evento</h5>
                                </div>
                                <div className="card-body">
                                    <div className="mb-3">
                                        <label className="form-label">Nombre evento</label>
                                        <input type="text" value={forms.selectedHotels.map((hotel) => hotel.nombreHotel).join(", ")} className="form-control" id="nombre_evento" required disabled />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Seleccione a los ejecutivos</label>
                                        <Select autoComplete="off" isMulti options={administradoresOptions} value={forms.selectedExecutives} onChange={(selected) => handleChange(selected, "selectedExecutives")} placeholder="Seleccione ejecutivos" className={forms.errors.selectedExecutives ? "error-border" : ""} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Tipo de evento</label>
                                        <select autoComplete="off" className={`form-control ${forms.errors.tipodeeventos ? "error-border" : ""}`} value={forms.tipodeeventos} onChange={(event) => handleChange(event.target.value, "tipodeeventos")}>
                                            {tiposDeeventosSelect.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Informacion de evento</h5>
                                </div>
                                <div className="card-body">
                                    <div className="mb-3">
                                        <label className="form-label">Escoger Salones para el evento</label>
                                        <input type="text" value={forms.selectedSalones.map((salon) => salon.nombreSalon).join(", ")} className="form-control" id="salones" required disabled />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Estado del evento</label>
                                        <select autoComplete="off" id="estadoEvento" className={`form-control ${forms.errors.estadoEvento ? "error-border" : ""}`} value={forms.estadoEvento} onChange={(event) => handleChange(event.target.value, "estadoEvento")}>
                                            <option value="" disabled>
                                                Selecciona un estado
                                            </option>
                                            {estadosEvento.map((estado) => (
                                                <option key={estado.id_estado} value={estado.id_estado}>
                                                    {estado.nombre_estado}
                                                </option>
                                            ))}
                                        </select>
                                        <br />
                                        {colorEstado && (
                                            <div role="alert" className="fade alert alert-primary show" style={{ backgroundColor: colorEstado, color: "#fff" }}>
                                                <div className="d-flex align-items-center">
                                                    <i className="ti ti-info-circle h2 f-w-400 mb-0"></i>
                                                    <div className="flex-grow-1 ms-3">Color segun el estado seleccionado</div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ListaEventoTemporal type="crear" />
                    <ListaEventoAsignados ListaEventoTemporal={forms.listaEventosAsignados} functions={eliminarEventos} />

                    <div className="row">
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Informacion de evento</h5>
                                    <p>Por favor, complete todos los campos antes de continuar. Esta información es esencial para procesar su solicitud y asegurarse de que podamos brindarle el mejor servicio posible. Gracias por su colaboración.</p>
                                </div>
                                <div className="card-body">
                                    <div className="mb-3">
                                        <label className="form-label">Hotel Seleccionado</label>
                                        <input autoComplete="off" type="text" value={forms.nombreEvento} onChange={(event) => handleChange(event.target.value, "nombreEvento")} className={`form-control ${forms.errors.nombreEvento ? "error-border" : ""}`} id="nombreEvento" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Ingresos $ del evento</label>
                                        <input autoComplete="off" type="number" value={forms.ingresoMonto} onChange={(event) => handleChange(event.target.value, "ingresoMonto")} className={`form-control ${forms.errors.ingresoMonto ? "error-border" : ""}`} id="ingresoMonto" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Cantidad personas</label>
                                        <input autoComplete="off" type="text" value={forms.cantidadPersonas} onChange={(event) => handleChange(event.target.value, "cantidadPersonas")} className={`form-control ${forms.errors.cantidadPersonas ? "error-border" : ""}`} id="cantidadPersonas" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Montaje del evento</label>
                                        <input autoComplete="off" type="text" value={forms.montajeEvento} onChange={(event) => handleChange(event.target.value, "montajeEvento")} className={`form-control ${forms.errors.montajeEvento ? "error-border" : ""}`} id="montajeEvento" />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Notas del evento</label>
                                        <textarea autoComplete="off" id="textarea" rows="3" placeholder="Mis notas" value={forms.notasEvento} onChange={(event) => handleChange(event.target.value, "notasEvento")} className={`form-control ${forms.errors.notasEvento ? "error-border" : ""}`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0">Asignar Empresa Y Cliente</h5>
                                    <button
                                        className="btn btn-danger"
                                        onClick={(e) => {
                                            e.preventDefault(); // Previene el comportamiento predeterminado del formulario
                                            borrarDatos(); // Llama a tu función
                                        }}
                                    >
                                        Deseleccionar empresa
                                    </button>
                                </div>

                                <div className="card-body">
                                    <div className="mb-3">
                                        <label className="form-label">Seleccione la empresa</label>
                                        <Select
                                            autoComplete="off"
                                            options={empresasOptions}
                                            value={forms.empresaSeleccionada}
                                            onChange={(selected) => {
                                                handleChange(selected, "empresaSeleccionada");
                                                ejecutarFuncionAdicional(selected, 1);
                                            }}
                                            placeholder="Seleccione empresa"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Seleccione el cliente segun la empresa</label>
                                        <Select
                                            autoComplete="off"
                                            options={clienteOptions}
                                            value={forms.clienteSeleccionado}
                                            onChange={(selected) => {
                                                handleChange(selected, "clienteSeleccionado");
                                                seleccionarCliente(selected);
                                            }}
                                            placeholder="Seleccione cliente"
                                            isDisabled={!forms.empresaSeleccionada}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Nombre del Cliente</label>
                                        <input type="text" value={forms.datosCliente?.nombre_cliente || ""} className="form-control" id="nombre_evento" required disabled />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Correo del Cliente</label>
                                        <input type="text" value={forms.datosCliente?.correo_cleinte || ""} className="form-control" id="nombre_evento" required disabled />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Telefono del Cliente</label>
                                        <input type="text" value={forms.datosCliente?.telefono_cliente || ""} className="form-control" id="nombre_evento" required disabled />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="submit" className="btn btn-dark" disabled={!forms.usuariosPersmisos}>
                            Editar Evento
                        </button>
                    </div>
                </fieldset>
            </form>
            {/* Componente del Modal */}
            <ModalMostrarCalendario open={openModal} handleClose={handleClose} />
        </div>
    );
};
